import { Component, OnInit, ViewChild } from '@angular/core';
import { MakeViewModel, Model } from '../../manage-components/manage-components.model';
import { ManageComponentsService } from '../../manage-components/manage-components.service';
import { ModelSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
import { SetupModelsService } from '../../setup-models/setup-models.service';
import { ChainActivePartModel, ChainActivePartVM, ChainDescriptionModel, DealershipsCustomers, PartConfiqQuoteBillingDetails, UserDealerGroup, UserDealerGroupDealerships, UserQuoteHistory } from '../../setup-models/setup-models.model';
import { MatTableDataSource } from '@angular/material/table';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog } from '@angular/material/dialog';
import { RequestNewChainModelComponent } from '../request-new-chain-model/request-new-chain-model.component';
import { BillingDetailComponent } from '../billing-detail/billing-detail.component';
import { ConfirmPopUpComponent } from '../confirm-pop-up/confirm-pop-up.component';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../../../../app/app.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { BillingConfirmationPopupComponent } from '../billing-confirmation-popup/billing-confirmation-popup.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-track-care-search',
  templateUrl: './track-care-search.component.html',
  styleUrls: ['./track-care-search.component.scss']
})
export class TrackCareSearchComponent implements OnInit {
  filteredMakeViewModel: MakeViewModel[] = [];
  MakeViewModel: MakeViewModel[] = [];
  familyId: number = 0;
  makeid: string = "";
  make_auto: number = 0;
  searchDiv: boolean;
  ModelList: Model[] = [];
  filteredModels: Model[] = [];
  filerModelList: GenericIdName[];
  serialNumber: string = "";
  model_auto: number = 0;
  chainDescriptionModel: ChainDescriptionModel[];
  dataSource = new MatTableDataSource<ChainDescriptionModel>([]);
  tableDataLoading: boolean;
  chainAutoID: number=0;
  newRow: boolean;
  tableDataLoadingComponent: boolean;
  dataSource_ = new MatTableDataSource<ChainActivePartModel>([]);
  displayedColumns_ = ['PartNo', 'comparttype', 'desc', 'partline', 'qauantityRequired', 'qtyinstock', 'costeach', 'costtotal', 'addQuote'];
  displayedColumns = ['ChainDesc', 'ModelSerialNumberStart', 'ModelSerialNumberEnd', 'Pitch', 'NumberOfLinks'];
id:number=0;
  equipmentId:number;
  constructor(public _componentService: ManageComponentsService,
    private _favouriteDialogService: FavouriteDialogService,
    private _setupModelService: SetupModelsService,
    private _notify: NotificationsService,
    private _dialog: MatDialog, public _modelService: SetupModelsService,
    public dialog: MatDialog,
    private _equipmentService:ManageEquipmentService, private route:ActivatedRoute,
    private _appService: AppService,private datePipe: DatePipe) { }

  ngOnInit(): void {
    this._appService.setPageTitle("Part Search");
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this.loadAllMakeList();
    this.route.paramMap.subscribe(params => {
      this.id = +params.get('id');
      
     
    });
    this.GetUserDealerGroup();
  }

  async loadAllMakeList() {
    try {
      const result = await this._componentService.GetMakeFromFamily(this.familyId).toPromise();
      
      this.MakeViewModel = result;
      this.filteredMakeViewModel = result;
      this.loadModelList();
  
    } catch (error) {
      console.error('Error fetching make list:', error);
    }
  }
  
  userDealerGroup: UserDealerGroup[]=[];
  dealerGroupId:number;
  GetUserDealerGroup() {
    this._modelService.GetUserDealerGroup().subscribe(result => {

      result.forEach(x=>{
        if(x.Email!=null){
          this.userDealerGroup.push(x);
        }
      });
       if(result!=null){
        this.dealerGroupId= this.userDealerGroup[0].Id;

       }
    })
  }

  onSelectMake(event: any) {
    let id = this.filteredMakeViewModel.find(f => f.Makedesc == event.value).Make_auto
    this.makeid = id.toString();
    this.make_auto = id;
    this.loadModelList();
  }

  MakeChanged(event: any) {
    if (event.target.value != "") {
      if (event.target.value.length >2) {
        const filterValue = event.target.value.toLowerCase();
        this.filteredMakeViewModel = this.MakeViewModel.filter(option => option.Makedesc.toLowerCase().includes(filterValue));
      } else {
        this.filteredMakeViewModel = this.MakeViewModel;
      }
    } else {
      this.make_auto = null;
      this.filteredMakeViewModel = this.MakeViewModel;

    }
  }
  async loadModelList() {
    let makeArray = [];
    let familyArray = [];
  
    makeArray.push(this.makeid);
  
    const params: ModelSelectionFilter = {
      Families: familyArray,
      Makes: makeArray
    };
  
    try {
      const r = await this._favouriteDialogService.GetModelsAvailable(params).toPromise();
  
      if (r) {
        this.filerModelList = r;
        this.ModelList = this.filerModelList.map(model => ({ Id: model.Id, Title: model.Name }));
        this.filteredModels = this.ModelList;
        
        this.loadEquipmentData(this.id);
      }
    } catch (error) {
      console.error('Error fetching model list:', error);
    }
  }
  
  changeModelAutoComplete(event: any) {
    if (event.target.value != "") {
      if (event.target.value.length >2) {
        const filterValue = event.target.value.toLowerCase();
        this.filteredModels = this.ModelList.filter(option => option.Title.toLowerCase().includes(filterValue));
      }else{
          this.filteredModels = this.ModelList;
      }
    } else {
      this.filteredModels = this.ModelList;
    }
    
  }
  onModelSelected(event: any) {
    let id = this.filteredModels.find(f => f.Title == event.value).Id;
    this.model_auto = id;
  }

  getChainDetailFiltered() {
    this.dataSource=new MatTableDataSource<ChainDescriptionModel>([]);
    if (this.model_auto > 0) {
      this.tableDataLoading = true;
      this._setupModelService.GetChainDetailFiltered(this.model_auto, this.make_auto, this.serialNumber).subscribe(result => {
        if (result != null) {
          this.chainDescriptionModel = result;
          this.dataSource.data = result;
          if(this.dataSource.data.length>0){
            this.chainAutoID=this.dataSource.filteredData[0].ChainAutoId;
           
              this.loadChainActivePartInfo();
              this.getUserQuoteHistory();
          }
        }
        this.searchDiv = true;
        this.tableDataLoading = false;

      })
    } else {
      this._notify.warn("Info", 'Please select a model')
    }
  }

  selectRow(row) {
    this.chainAutoID = row.ChainAutoId;
    this.isHistoryClick=false;
    this.partQuoteId=null;
    this.loadChainActivePartInfo();
  }

  requestANewModelPopup() {

        const dialogRef = this._dialog.open(RequestNewChainModelComponent, {
      width: "300px",
      data: {
        modelName:this.modelTitle,
        MakeName:this.makeTitle,
      }
     
    });
    dialogRef.afterClosed().subscribe(edited => {

    });
  }

  chainActivePartModel: ChainActivePartModel[];
  HavingQuote: Boolean;
  loadChainActivePartInfo() {
    this.tableDataLoadingComponent = true;
    this._modelService.GetChainActiveParts(this.model_auto, this.chainAutoID, 0,"").subscribe(result => {
      this.dataSource_.data = result
      if (this.dataSource_.data.filter(x => x.AddToQuote == 1).length > 0) {
        this.HavingQuote = true
      } else {
        this.HavingQuote = false;
      }
      this.newRow = true;
      this.tableDataLoadingComponent = false;
      this.getConfigQuote();
    })
  }
  isHistoryClick: boolean=false;
  partQuoteId:number;
  datetime:Date= new Date();

  isFromQuote:boolean=false;
  loadChainActivePartQuoteInfo(chainId: number, partQuoteId: number, isHistoryClick: number,modelId:number,date:Date) {
    this.isFromQuote=true;
    this.datetime=date;
    
    if (isHistoryClick == 1) {
      this.isHistoryClick = true;
    }
    
    this.partQuoteId= partQuoteId;
    this.chainAutoID=chainId;
    this.tableDataLoadingComponent = true;
    
    this._modelService.GetChainActiveParts(modelId, chainId, partQuoteId,date.toString()).subscribe(result => {
      this.dataSource_.data = result
      if (this.dataSource_.data.filter(x => x.AddToQuote == 1).length > 0) {
        this.HavingQuote = true
      } else {
        this.HavingQuote = false;
      }
      this.newRow = true;
      this.tableDataLoadingComponent = false;
      this.getConfigQuote();
      this.GetPartQuoteComment();
    })
  }
  onQuantityChange(compartId: number, QuantityReq: number, quantity: number) {
    const element = this.dataSource_.data.find(item => item.CompartId === compartId);
   
      if (element) {
        element.CostTotal = QuantityReq * element.Cost;  // Calculate total cost based on quantity and cost
      }
    
    this.dataSource_.data = [...this.dataSource_.data];
  }

  popUpBilling() {
    const dialogRef = this._dialog.open(BillingDetailComponent, {
      width: "500px",
      data: {
        ChainID: this.chainAutoID,
      }
    });
    dialogRef.afterClosed().subscribe(edited => {

    });
  }

  PartConfiqQuoteBillingDetails: PartConfiqQuoteBillingDetails;
 
  getConfigQuote() {
    this.PartConfiqQuoteBillingDetails=null;
    this._modelService.GetPartConfiqQuote(this.chainAutoID).subscribe(result => {
      if (result != null) {
        this.PartConfiqQuoteBillingDetails = result;
        if(this.PartConfiqQuoteBillingDetails!=null){
          
        }
      }else{
        
      }
    })
  }
  ChainActivePartVM: ChainActivePartVM;
  SaveQuoteDetails() {
if(!this.isHistoryClick){
  this.ChainActivePartVM = new ChainActivePartVM();

  this.ChainActivePartVM.chainId = this.chainAutoID;
  this.ChainActivePartVM.chainPartData = this.dataSource_.data.filter(x => x.AddToQuote == 1);
 if(this.ChainActivePartVM.chainPartData.length>0){
  this._modelService.SaveQuoteDetails(this.ChainActivePartVM).subscribe(result => {

    if (result != null) {
      this.partQuoteId= result;
      this.getUserQuoteHistory();
      this._notify.success('Quote details saved successfully')
    }

  })
 }else{
  this._notify.info('Please Select Quotes.!')
 }
}else{
this.OpenConfirmationBox();
}
    
   
  }
  UserQuoteHistory: UserQuoteHistory[] = [];
  
  getUserQuoteHistory() {
    this._modelService.getUserQuoteHistory(this.model_auto).subscribe(result => {
      if (result != null) {
        this.UserQuoteHistory = result;
        console.log(this.UserQuoteHistory);
      }
    })
  }
  OpenConfirmationBox() {
    const dialogRef = this._dialog.open(ConfirmPopUpComponent, {
      width: "500px",
      data: {
        ChainID: this.chainAutoID,
        QuoteData: this.dataSource_.data
      }
    });
    dialogRef.afterClosed().subscribe(edited => {
      if(edited){
        
        this.loadChainActivePartQuoteInfoData(this.chainAutoID,this.partQuoteId,this.model_auto);
        this.partQuoteId=0;
      }
    });
  }

  quoteComment:string="";

  EmailSend() {
    let date1;
    if(!this.isFromQuote){
      date1=this.datePipe.transform(this.datetime, 'yyyy-MM-dd\'T\'HH:mm:ss');
    }else{
      date1= this.datetime;
    }
      
    this._modelService.EmailQuoteDetails(this.quoteComment,this.partQuoteId, date1 ).subscribe(result => {

      if (result != null) {
        this._notify.success('Email sent successfully')
      }

    })
  }

  GetPartQuoteComment() {
    this.quoteComment=null;
     this._modelService.GetPartQuoteComment(this.partQuoteId).subscribe(result => {
       if (result != null) {
        this.quoteComment= result;
       }else{
        this.quoteComment="";
       }
 
     })
}
modelTitle:string="";
makeTitle:string="";

async loadEquipmentData(id) {
  try {
    const data = await this._equipmentService.GetPartMakeModel(id).toPromise();
    
    if (data) {
      this.model_auto = data[0].Model_Auto;
      this.make_auto = data[0].Make_Auto;

      this.modelTitle = this.getModelTitle(data[0].Model_Auto);
      this.makeTitle = this.getMakeDescription(data[0].Make_Auto);
      this.getChainDetailFiltered();
    } else {
    }
  } catch (error) {
  }
}

  getMakeDescription(makeAutoId) {
      const make = this.filteredMakeViewModel.find(m => m.Make_auto === makeAutoId);
      if (make) {
          return make.Makedesc;
      } else {
          console.warn(`Make with ID ${makeAutoId} not found.`);
          return 'Unknown Make';
      }
  }
 
 
 getModelTitle(modelAutoId){
  if(this.filteredModels!=null)
  return this.filteredModels.find(a=>a.Id===modelAutoId).Title;
 }
 @ViewChild('autoCompleteInput1', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger1: MatAutocompleteTrigger;
  @ViewChild('autoCompleteInput2', { static: false, read: MatAutocompleteTrigger }) autoCompleteTrigger2: MatAutocompleteTrigger;
 resetFields() {
 
  this.autoCompleteTrigger1.closePanel();
  this.autoCompleteTrigger1.writeValue('');
  this.autoCompleteTrigger2.closePanel();
  this.autoCompleteTrigger2.writeValue('');
 this.searchDiv=false;
 this.newRow=false;
 this.dataSource_.data=[];
 this.familyId=0;
 this.makeid="";
 this.UserQuoteHistory=[];
this.loadAllMakeList();

}
Istrue:number;
OpenConfirmPopup(){
  let dialogRef = this.dialog.open(BillingConfirmationPopupComponent, {
    width: '400px',
  });
}
//appUris: AppUris;
DownLoadPartsQuote() {
  let date1;
    if(!this.isFromQuote){
      date1=this.datePipe.transform(this.datetime, 'yyyy-MM-dd\'T\'HH:mm:ss');
    }else{
      date1= this.datetime;
    }
  window.open(this._appService.getBaseURL() + 'api/SetupEquipment/GetPartQuotePdf?partQuoteId=' + this.partQuoteId.toString() + '&date=' + date1, '_blank');
   
}

loadChainActivePartQuoteInfoData(chainId: number, partQuoteId: number, modelId:number) {
  this.isFromQuote=true;
  
  // if (isHistoryClick == 1) {
  //   this.isHistoryClick = true;
  // }
  
  this.partQuoteId= partQuoteId;
  this.chainAutoID=chainId;
  this.tableDataLoadingComponent = true;
  
  this._modelService.GetChainActiveParts(modelId, chainId, partQuoteId,"").subscribe(result => {
    this.dataSource_.data = result
    this.HavingQuote = false;
    this.isHistoryClick=false;
    this.newRow = true;
    this.tableDataLoadingComponent = false;
    this.getConfigQuote();
    this.GetPartQuoteComment();
  })
}
}
